// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3724":"VoltoFormBlockEdit","4776":"VoltoFormBlockView","5240":"volto-dropdownmenu-manage"}[chunkId] + "." + {"3724":"dd6eb74e","4776":"0b6464b2","5240":"f0610ba2"}[chunkId] + ".chunk.css";
};